module.exports = __webpack_public_path__ + "img/Nationwide Express.ece333c9.png";